import React from 'react';
import './Spinner.css';

const Spinner = ({ color, ...props }) => {
  const dotStyle = {
    backgroundColor: color
  };

  return (
    <div className="spinkit-spinner" {...props}>
      <div className="bounce1" style={dotStyle} />
      <div className="bounce2" style={dotStyle} />
      <div className="bounce3" style={dotStyle} />
    </div>
  );
};

Spinner.defaultProps = {
  color: '#333'
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js